function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import classnames from 'classnames';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import classes from './rectangle-input.scss';
import Notification from './components/notification';
export const RectangleInput = ({
  input = {},
  label,
  icon,
  formType = 'text',
  placeholder,
  className,
  labelClassName,
  wrapperClassName,
  dataInput,
  disabled,
  errorClassName,
  errorMessageClassName,
  hideError = false,
  hideErrorWhenFocused = false,
  meta: {
    touched = undefined,
    active = undefined,
    error = undefined
  } = {}
}) => {
  const [focused, setFocused] = useState(false);
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const onFocus = event => {
    const onFocus = input === null || input === void 0 ? void 0 : input.onFocus;
    if (onFocus) {
      onFocus(event);
    }
    setFocused(true);
  };
  const onBlur = event => {
    const onBlur = input === null || input === void 0 ? void 0 : input.onBlur;
    if (onBlur) {
      onBlur(event);
    }
    setFocused(false);
  };
  const onClickShowPassword = () => {
    setIsPasswordShown(!isPasswordShown);
  };
  const onMouseUpDownPassword = event => {
    event.preventDefault();
  };
  const isPasswordType = formType === 'password';
  const isReadyToShowError = touched && !active && !(hideErrorWhenFocused && focused);
  const showError = error && isReadyToShowError;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.wrapper, wrapperClassName)
  }, label && /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.label, labelClassName)
  }, label), icon, /*#__PURE__*/React.createElement("div", {
    className: classes.inputWrapper
  }, /*#__PURE__*/React.createElement("input", _extends({}, input, {
    type: isPasswordType ? isPasswordShown ? 'text' : 'password' : formType,
    onFocus: onFocus,
    onBlur: onBlur,
    placeholder: placeholder,
    disabled: disabled,
    className: classnames(classes.input, className, {
      [classes.inputError]: showError
    }, errorClassName && {
      [errorClassName]: showError
    }),
    "data-input": dataInput
  })), isPasswordType && /*#__PURE__*/React.createElement("div", {
    className: classes.passwordVisibilityButton,
    onClick: onClickShowPassword,
    onMouseDown: onMouseUpDownPassword,
    onMouseUp: onMouseUpDownPassword
  }, isPasswordShown ? /*#__PURE__*/React.createElement("div", {
    className: classes.passwordVisibilityBlock
  }, /*#__PURE__*/React.createElement(VisibilityOff, null), /*#__PURE__*/React.createElement("span", null, "Hide")) : /*#__PURE__*/React.createElement("div", {
    className: classes.passwordVisibilityBlock
  }, /*#__PURE__*/React.createElement(Visibility, null), /*#__PURE__*/React.createElement("span", null, "Show")))), !hideError && isReadyToShowError && /*#__PURE__*/React.createElement(Notification, {
    className: errorMessageClassName,
    message: error
  }));
};